import { Component, OnInit } from '@angular/core';
import { environment } from 'src/environments/environment';
import { ChartOptions, ChartType, ChartDataSets } from 'chart.js';
import { Label } from 'ng2-charts';
import { CommonService } from 'src/app/services/common.service';
import ChartDataLabels from 'chartjs-plugin-datalabels';
import * as Chart from 'chart.js';
import { ActivatedRoute, Router } from '@angular/router';
@Component({
  selector: 'app-analytics',
  templateUrl: './analytics.component.html',
  styleUrls: ['./analytics.component.scss'],
})
export class AnalyticsComponent implements OnInit {
  RESOURCE_SERVER_URL = environment.RESOURCE_SERVER_URL;
  fraudIcon =this.RESOURCE_SERVER_URL +'/assets/images/Color_full.svg';
  fraudIconLight =this.RESOURCE_SERVER_URL +'/assets/images/Color_light.svg';
  fraudIconDark =this.RESOURCE_SERVER_URL +'/assets/images/Color_dark.svg';
  page: number = 1;
  totalItems: number = 1;
  itemsPerPage: number = 5;
  isLoading=false;
  countdetails
  paginationActions: Array<any> = ['prev', 'next', 'first', 'last'];
  itemsPerPageOptions: Array<number> = [5, 10, 50, 100];
  analitics = [
  ];
  constructor(private commonService: CommonService,private route: ActivatedRoute,
    private router: Router) {
    this.isLoading=true
    this.getallpolicyCount();
    this.getGeneralQueueData()
  }
  pieChartType: ChartType = 'pie';
  public pieChartLabels: string[] = [
    'No Threat',
    'Potential Fraud Claims',
    'Watch List',
    'Identified Fraud',
    'Cleared',
  ];
  public pieChartOptions: ChartOptions = {
    responsive: true,
    plugins: {
      datalabels: {
        display: false, // Disable the datalabels plugin
      },
    },
    legend: {
      position: 'top',
      display: false,
      labels: {
        usePointStyle: true,
        boxWidth: 6,
      },
    },
    layout: {
      padding: {
        left: 5,
        right: 5,
        top: 30,
        bottom: 30,
      },
    },
  };
  public pieChartData: number[] = [];
  public pieChartColors: any[] = [
    {
      backgroundColor: ['#009DE0', '#F26A02', '#9F9614', '#D2282E', '#179B2C'],
    },
  ];
  horizantalbarChartLabels3: Label[] = ['W1', 'W2', 'W3', 'W4'];
  horizantalbarChartLegend3 = true;
  horizantalbarChartType3: ChartType = 'bar';
  public horizantalbarChartData3: any[] = [
    {
      data: [50, 180, 60, 146],
      label: 'No Threat',
      barThickness: 80,
      barPercentage: 1,
      borderColor: '#FFFFFF',
      backgroundColor: '#009DE0',
    },
    {
      data: [150, 120, 20, 146],
      barThickness: 80,
      label: 'Potential Fraud Claims',
      barPercentage: 1,
      borderColor: '#FFFFFF',
      backgroundColor: '#F26A02',
    },
    {
      data: [100, 60, 190, 146],
      barThickness: 80,
      label: 'Watch List',
      barPercentage: 1,
      borderColor: '##FFFFFF',
      backgroundColor: '#9F9614',
    },
    {
      data: [100, 160, 140, 146],
      barThickness: 80,
      label: 'Identified Fraud',
      barPercentage: 1,
      borderColor: '##FFFFFF',
      backgroundColor: '#D2282E',
    },
    {
      data: [200, 20, 40, 146],
      barThickness: 80,
      label: 'Cleared',
      barPercentage: 1,
      borderColor: '##FFFFFF',
      backgroundColor: '#179B2C',
    },
  ];
  public horizantalbarChartOptions: any = {
    scaleShowVerticalLines: false,
    title: {
      display: true,
      text: '',
      position: 'top',
    },
    plugins: {
      datalabels: {
        display: false, // Disable the datalabels plugin
      },
    },
    responsive: true,
    scales: {
      xAxes: [
        {
          stacked: true,
          gridLines: { display: false },
          ticks: {
            display: true, //this will remove only the label
          },
        },
      ],
      yAxes: [
        {
          stacked: true,
          gridLines: { display: true },
          ticks: {
            display: true, //this will remove only the label
            beginAtZero: true,
            max: 1000,
          },
        },
      ],
      plugins: { datalabels: { anchor: 'end', align: 'end' } },
    },
    legend: {
      position: 'bottom',
      labels: {
        usePointStyle: true,
        boxWidth: 6,
      },
    },
  };
  ngOnInit(): void {
    Chart.plugins.register(ChartDataLabels);
    this.extendPieChartWithConnectingLines();
  }
  scoreCalculation(percentage) {
    return `${percentage.replace(' ', '').toLowerCase()}`;
  }
  async onPageAction(value, pagesize) {
    this.page = value;
    await this.getGeneralQueueData();
  }
  itemsPerPageFunction(size) {
    this.itemsPerPage = size;
    let startIndex = 1;
    this.onPageAction(startIndex, this.itemsPerPage);
  }
  async getallpolicyCount() {
    try{
    let clientNumberUrl =
      environment.API_CLAIM_REGISTRATION_SERVER_URL + 'count';
    let res = await this.commonService.commonPost(clientNumberUrl, {});
    if (res) {
      this.countdetails=res.body
      this.pieChartData=[10,this.countdetails.probableFraudClaim,this.countdetails.watchList,this.countdetails.identifiedFraud,this.countdetails.cleared]
    }
    this.isLoading=false;
  }catch(error){
      this.isLoading=false;
    }
  }
  extendPieChartWithConnectingLines() {
    const originalDraw = Chart.controllers.doughnut.prototype.draw;
    Chart.helpers.extend(Chart.controllers.doughnut.prototype, {
      draw: function (ease) {
        originalDraw.apply(this, arguments);

        const ctx = this.chart.ctx;
        const chartArea = this.chart.chartArea;
        const meta = this.getMeta();
        const arcs = meta.data;

        ctx.save();
        arcs.forEach((arc) => {
          const model = arc._model;
          const midAngle = (model.startAngle + model.endAngle) /2;
          const x = (model.outerRadius + 20) * Math.cos(midAngle); // Increased length
          const y = (model.outerRadius + 20) * Math.sin(midAngle); // Increased length
          const labelX = model.x + x;
          const labelY = model.y + y;

          const offsetX = x > 0 ? 10 : -10; // Offset to place label correctly at the end of the line
          const textAlign = x > 0 ? 'left' : 'right'; // Align text based on its position

          ctx.strokeStyle = model.backgroundColor;
          ctx.lineWidth = 2;
          ctx.beginPath();
          ctx.moveTo(model.x, model.y);
          ctx.lineTo(labelX, labelY);
          ctx.stroke();

          ctx.textAlign = textAlign;
          ctx.textBaseline = 'middle';
          ctx.font = 'normal 14px Arial'; // Adjust font size as needed
          ctx.fillStyle = '#000';
          ctx.fillText(
            this.chart.data.labels[arc._index],
            labelX + offsetX,
            labelY
          );
        });
        ctx.restore();
      },
    });
  }
  async getGeneralQueueData() {
    try {
      let url =
        environment.API_CONFIG_URL +
        'claimsOffice/claims?page=' +
        (this.page - 1) +
        '&size=' +
        this.itemsPerPage +
        '&searchName=' +
        encodeURIComponent('ADIDM');
      let response = await this.commonService.commonGet(url);
      this.analitics = response.body._links.item;
      this.totalItems = response.body._links._count;
      this.commonService.activateLoadingHomePage.emit(1);
    } catch (err) {
      console.log('Get API Error - Claim Queue Data', err);
    }
  }
  onRegisterDeath(data: any) {
    localStorage.setItem('isClaimant', 'N');
    console.log('data::', data);
    localStorage.setItem('claimID', data.summary['id']);
    localStorage.setItem(
      'claimReferenceNo',
      data.summary['claimReferenceNumber']
    );
    if (data.summary['reAssignedIndicator'] == '') {
      localStorage.setItem('routedClaimEnable', 'Y')
    }
    localStorage.setItem('clientNumber', data.summary['clientNumber']);
    this.router.navigate(
      [`/process-claims/claim-review/`, data.summary['id']],
      {
        relativeTo: this.route,
      }
    );
  }
  dynamicImage(value){
    return value=='Fraud'?'highRisk':"lightBlue";
  }
  roundValue(value){
    return Math.round(value)
  }
}
